var _rect, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 24,
    viewBox: "0 0 36 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.571289,
    y: 0.00119019,
    width: 35,
    height: 23.3363,
    rx: 2,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6787 5.55368H14.4448V17.785H21.6787V5.55368Z",
    fill: "#FF5F00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9042 11.6693C14.9031 10.4914 15.1868 9.32859 15.7338 8.26904C16.2809 7.20949 17.077 6.28094 18.0619 5.55368C16.8423 4.6517 15.3776 4.09077 13.8352 3.93501C12.2928 3.77924 10.7349 4.03492 9.33963 4.67283C7.94437 5.31075 6.768 6.30515 5.945 7.54238C5.12199 8.7796 4.68555 10.2097 4.68555 11.6693C4.68555 13.1289 5.12199 14.559 5.945 15.7963C6.768 17.0335 7.94437 18.0279 9.33963 18.6658C10.7349 19.3037 12.2928 19.5594 13.8352 19.4036C15.3776 19.2479 16.8423 18.6869 18.0619 17.785C17.077 17.0577 16.2809 16.1291 15.7339 15.0696C15.1868 14.01 14.9031 12.8473 14.9042 11.6693Z",
    fill: "#EB001B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4379 11.6693C31.438 13.1289 31.0016 14.559 30.1786 15.7962C29.3557 17.0335 28.1793 18.0279 26.7841 18.6658C25.3889 19.3037 23.831 19.5594 22.2886 19.4036C20.7463 19.2479 19.2816 18.6869 18.062 17.785C19.046 17.057 19.8415 16.1283 20.3884 15.0689C20.9354 14.0095 21.2196 12.8471 21.2196 11.6693C21.2196 10.4915 20.9354 9.32914 20.3884 8.26976C19.8415 7.21038 19.046 6.28168 18.062 5.55367C19.2816 4.65169 20.7463 4.09077 22.2886 3.935C23.831 3.77924 25.3889 4.03493 26.7841 4.67285C28.1793 5.31077 29.3557 6.30517 30.1786 7.5424C31.0016 8.77963 31.438 10.2098 31.4379 11.6693Z",
    fill: "#F79E1B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6489 16.4895V16.2391H30.7562V16.188H30.4829V16.2391H30.5903V16.4895H30.6489ZM31.1795 16.4895V16.1875H31.0957L30.9994 16.3952L30.903 16.1875H30.8192V16.4895H30.8783V16.2617L30.9687 16.4581H31.03L31.1204 16.2612V16.4895H31.1795Z",
    fill: "#F79E1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/Mastercard.4a320b3b7db8455c87cea0334038f2cc.svg";
export { ForwardRef as ReactComponent };